export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyDJjv2xSKepz23UlfZka8DbIuZQ5sEoH68",
        authDomain: "schule-neuenkirch-k2wp8.firebaseapp.com",
        databaseURL: "https://schule-neuenkirch-k2wp8-default-rtdb.firebaseio.com",
        projectId: "schule-neuenkirch-k2wp8",
        storageBucket: "schule-neuenkirch-k2wp8.appspot.com",
        messagingSenderId: "43715649025",
        appId: "1:43715649025:web:2aa05e46e38336ff066a00",
        measurementId: "G-Z0DKSB9T7T"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts